import { useQuery } from '@apollo/react-hooks';
import { GET_ROLES } from '../../graphql/role/query';
import { GetRoles } from '../../graphql/role/types/GetRoles';

export const useGetRoles = () => {
  return useQuery<GetRoles>(GET_ROLES, {
    fetchPolicy: 'network-only',
  });
};
